/** TopItemsList — ranked bar list of the top 8 items by quantity. */
import React, { useMemo } from 'react';
import { fmt$, fmtN, pct } from '../../../utils/formatUtils';

export default function TopItemsList({ categories }) {
  const items = useMemo(() => {
    const map = {};
    categories.forEach(cat => {
      cat.items.forEach(item => {
        const k = item.name.toLowerCase();
        if (!map[k]) map[k] = { name: item.name, qty: 0, revenueCents: 0 };
        map[k].qty          += item.qty;
        map[k].revenueCents += item.revenueCents;
      });
    });
    return Object.values(map).sort((a, b) => b.qty - a.qty).slice(0, 8);
  }, [categories]);

  const maxQty = Math.max(1, ...items.map(i => i.qty));

  return (
    <div className="sq__toplist">
      {items.map((item, i) => (
        <div key={i} className="sq__toprow">
          <span className="sq__toprank">#{i + 1}</span>
          <div className="sq__topinfo">
            <div className="sq__topname">{item.name}</div>
            <div className="sq__topbar-track">
              <div className="sq__topbar-fill" style={{ width: pct(item.qty, maxQty) }} />
            </div>
          </div>
          <div className="sq__topnums">
            <span className="sq__topqty">{fmtN(item.qty)}</span>
            <span className="sq__toprev">{fmt$(item.revenueCents / 100)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
